import { Routes } from '@angular/router';
import { LoginComponent } from './components/login/login.component';
import { RegisterComponent } from './components/register/register.component';
import { AuthCallbackComponent } from './components/auth-callback/auth-callback.component';
import { TelemetryAuthComponent } from './components/telemetry-auth/telemetry-auth.component';
import { authGuard } from './guards/auth.guard';

export const routes: Routes = [
  {
    path: 'login',
    component: LoginComponent
  },
  {
    path: 'register',
    component: RegisterComponent
  },
  {
    path: 'auth/callback',
    component: AuthCallbackComponent
  },
  {
    path: 'telemetry-auth',
    component: TelemetryAuthComponent
  },
  {
    path: '',
    children: [
      {
        path: '',
        redirectTo: 'sessions',
        pathMatch: 'full'
      },
      {
        path: 'leaderboard',
        canActivate: [authGuard],
        loadComponent: () => import('./components/points-leaderboard/points-leaderboard.component').then(m => m.PointsLeaderboardComponent)
      },
      {
        path: 'onboarding',
        canActivate: [authGuard],
        loadComponent: () => import('./components/onboarding/onboarding.component').then(m => m.OnboardingComponent)
      },
      {
        path: 'best-laps',
        canActivate: [authGuard],
        loadComponent: () => import('./components/best-laps/best-laps.component').then(m => m.BestLapsComponent)
      },
      {
        path: 'teams/:teamId/admin',
        canActivate: [authGuard],
        loadComponent: () => import('./components/team-admin/team-admin.component').then(m => m.TeamAdminComponent)
      },
      {
        path: 'sessions',
        loadComponent: () => import('./components/session-history/session-history.component').then(m => m.SessionHistoryComponent)
      },
      {
        path: 'session/:id',
        loadComponent: () => import('./components/current-session/current-session.component').then(m => m.CurrentSessionComponent)
      },
      {
        path: 'race/:id',
        loadComponent: () => import('./components/race-overview/race-overview.component').then(m => m.RaceOverviewComponent)
      },
      {
        path: 'seasons',
        canActivate: [authGuard],
        loadComponent: () => import('./components/season-list/season-list.component').then(m => m.SeasonListComponent)
      },
      {
        path: 'seasons/:id',
        canActivate: [authGuard],
        loadComponent: () => import('./components/season-detail/season-detail.component').then(m => m.SeasonDetailComponent)
      },
      {
        path: 'admin/users',
        canActivate: [authGuard],
        loadComponent: () => import('./components/admin-users/admin-users.component').then(m => m.AdminUsersComponent)
      }
    ]
  },
  {
    path: '**',
    redirectTo: 'sessions'
  }
];
